import {
  Accordion,
  Card,
  Group,
  Stack,
  Text,
  ThemeIcon,
  Title,
} from "@mantine/core";
import { IconTrophy } from "@tabler/icons-react";
import { useTranslation } from "next-i18next";
import { useEffect, useState } from "react";
import { Swords } from "../../common/icons/swords";
import {
  Elimination,
  EliminationMatchup,
  Event,
} from "../../common/events/event.schema";
import MatchupDisplay from "./MatchupDisplay";

export const RoundTitle = ({
  elimination,
  event,
}: {
  elimination: Elimination;
  event: Event;
}) => {
  const { t } = useTranslation();
  let roundTitle = `${t("Round")} ${elimination.round} - ${t("Table of")} ${
    elimination.size
  }`;
  if (elimination.round === event.eliminations.length)
    roundTitle = `${t("Round")} ${elimination.round} - ${t("Final")}`;
  if (elimination.round === event.eliminations.length - 1)
    roundTitle = `${t("Round")} ${elimination.round} - ${t("Semi final")}`;
  if (elimination.round === event.eliminations.length - 2)
    roundTitle = `${t("Round")} ${elimination.round} - ${t("Quarter final")}`;
  return <>{roundTitle}</>;
};

const EliminationDisplay = ({
  elimination,
  event,
  openMatch,
  showTitle,
}: {
  elimination: Elimination;
  event: Event;
  showTitle?: boolean;
  openMatch: (matchup: EliminationMatchup) => void;
}) => {
  const matchups = elimination.matchups;
  if (matchups.length === 0) {
    //fill with fake matchups
    // console.log(" elimination.size :", elimination.size);
    for (let index = 0; index < elimination.size / 2; index++) {
      matchups.push({ members: [] });
    }
  }
  // const heightPerPair = heightPer * 2;
  // console.log("maxMatchups :", maxMatchups);
  return (
    <Stack key={elimination.round}>
      {showTitle && (
        <Title order={3} fz="md">
          <RoundTitle event={event} elimination={elimination} />
        </Title>
      )}
      <Stack>
        {matchups.length > 0 &&
          matchups.map((matchup, i) => {
            if (matchup.members.length === 0 && matchup.winner)
              matchup.members = [matchup.winner];
            // if (elimination.round === 1 && !a && !b) return;
            // if (!b) return;
            // console.log("a :", a);
            // console.log("b :", b);
            return (
              <Card
                key={i}
                style={{
                  textAlign: "center",
                }}
              >
                <MatchupDisplay
                  elimination={elimination}
                  matchup={matchup}
                  event={event}
                  openMatch={openMatch}
                  matchupIndex={i}
                />
              </Card>
            );
          })}
      </Stack>
    </Stack>
  );
};
const EliminationAccordion = ({
  event,
  openMatch,
  ...others
}: {
  event: Event;
  openMatch: (matchup: EliminationMatchup) => void;
}) => {
  //   const matchups = elimination.matchups;
  const [roundString, setRoundString] = useState<string | null>("1");
  const [maxRound, setMaxRound] = useState(1);
  useEffect(() => {
    let r = 1;
    event.eliminations.map((e) => {
      if (e.complete) r++;
    });
    if (r > maxRound) {
      setMaxRound(r);
      setRoundString(r.toString());
    }
  }, [maxRound, event]);
  return (
    <Accordion value={roundString} onChange={setRoundString} {...others}>
      {event.eliminations.map((e) => (
        <Accordion.Item key={e.round} value={e.round.toString()}>
          <Accordion.Control disabled={e.round > maxRound}>
            <Group>
              <Text size="sm">
                <RoundTitle event={event} elimination={e} />
              </Text>
              {maxRound > e.round && (
                <ThemeIcon variant="light" size="xs" color="green">
                  <IconTrophy />
                </ThemeIcon>
              )}
              {maxRound === e.round && (
                <ThemeIcon variant="light" size="xs">
                  <Swords />
                </ThemeIcon>
              )}
            </Group>
          </Accordion.Control>
          <Accordion.Panel>
            <EliminationDisplay
              elimination={e}
              event={event}
              openMatch={openMatch}
            />
          </Accordion.Panel>
        </Accordion.Item>
      ))}
    </Accordion>
  );
};
export default EliminationAccordion;
